import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const QRCode: React.FC<IconProps> = ({
  color = '#fff',
  size = 32,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M21.3333 22.6667V21.3333H17.3333V19.3333C17.3333 18.2288 18.2288 17.3333 19.3333 17.3333H21.3333V20H24V22.6667H22.6667V25.3333H20V28H19.3333C18.2288 28 17.3333 27.1046 17.3333 26V24H20V22.6667H21.3333ZM28 26C28 27.1046 27.1046 28 26 28H22.6667V25.3333H25.3333V22.6667H28V26ZM4 6C4 4.89543 4.89543 4 6 4H12.6667C13.7712 4 14.6667 4.89543 14.6667 6V12.6667C14.6667 13.7712 13.7712 14.6667 12.6667 14.6667H6C4.89543 14.6667 4 13.7712 4 12.6667V6ZM17.3333 6C17.3333 4.89543 18.2288 4 19.3333 4H26C27.1046 4 28 4.89543 28 6V12.6667C28 13.7712 27.1046 14.6667 26 14.6667H19.3333C18.2288 14.6667 17.3333 13.7712 17.3333 12.6667V6ZM4 19.3333C4 18.2288 4.89543 17.3333 6 17.3333H12.6667C13.7712 17.3333 14.6667 18.2288 14.6667 19.3333V26C14.6667 27.1046 13.7712 28 12.6667 28H6C4.89543 28 4 27.1046 4 26V19.3333ZM24 17.3333H26C27.1046 17.3333 28 18.2288 28 19.3333V20H24V17.3333ZM8 8V10.6667H10.6667V8H8ZM8 21.3333V24H10.6667V21.3333H8ZM21.3333 8V10.6667H24V8H21.3333Z"
      fill={color}
    />
  </svg>
)
